import { Attribute, Relationship, Resource } from 'json-api';
import { AtomResource } from '../classes/atom-resource';
import { TrafficManager } from './traffic-manager.resource';

@Resource({
  type: 'users',
})
export class Users extends AtomResource {
  @Attribute() name?: string;
  @Attribute() api?: boolean;
  @Relationship() trafficmanagers?: TrafficManager[];
}
